import { setDiagramInfluenceAnalysis as setDiagramInfluenceAnalysisDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    source?: String,
    discovery_rule_id?: String,
}

export async function setDiagramInfluenceAnalysis ({
    source,
    discovery_rule_id,
    eventEmitter,
}: Props) {
    setDiagramInfluenceAnalysisDiagram(source,discovery_rule_id);
    eventEmitter.emit(Event.setDiagramInfluenceAnalysis);
};
